import {
  FormControl,
  InputAdornment,
  TextField,
  useTheme,
} from "@mui/material";
import { Search } from "lucide-react";
import { ISearchInput } from "./Types/Inputs.types";

export const SearchInput = ({
  id,
  value,
  onChange,
  placeholder,
  sx,
}: ISearchInput) => {
  const theme = useTheme();

  return (
    <FormControl id={"formcontrol"}>
      <TextField
        id={id}
        value={value}
        onChange={onChange}
        sx={{
          "& .MuiInputBase-root": {
            backgroundColor: `${theme.palette.backgroundSecondary} !important`,
            borderRadius: "0.5rem !important",
            border: "none",
            color: theme.palette.text.primaryCta,
            height: "2.25rem",
          },
          "& .MuiInputBase-input": {
            padding: "0.65rem 0.5rem",
            fontSize: "0.75rem",
          },
          "& fieldset": {
            border: "none",
          },
          ...sx,
        }}
        placeholder={placeholder ?? ""}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search size={"1.2rem"} color={theme.palette.systemSecondary01} />
            </InputAdornment>
          ),
        }}
      />
    </FormControl>
  );
};
